<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
            <v-card-title>
                <span class="headline">Detalles del Plan</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-switch
                                :disabled="disabled || loading"
                                v-model="subscription_paused"
                                label="Suspender Cuenta"
                                :value="subscription_paused"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text @click="hideDialog">Cancelar</v-btn>
                <v-btn color="primary" :disabled="loading || disabled" :loading="loading" text @click="update">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {ApiUtils} from '@/utils/ApiUtils'
import {mapMutations} from 'vuex'

export default {
    data() {
        return {
            loading: false,
            disabled: true,
            id: null,
            dialog: false,
            subscription_paused: 0,
        }
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        reset() {
            const vm = this
            vm.id = null
            vm.subscription_paused = 0
        },
        async showDialog(providerId) {
            const vm = this
            vm.dialog = true

            vm.disabled = true
            const response = await ApiUtils.makeGet(`provider/${providerId}/account`)

            if (!response.ok) {
                const json = await response.json()
                vm.showSnackBar(json.message || 'Ocurrió un error consultando la cuenta')
                vm.disabled = true
                return
            }

            const json = await response.json()
            vm.id = json.result.provider.id
            vm.subscription_paused = json.result.provider.subscription_paused
            vm.disabled = false
        },
        hideDialog() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        async update() {
            const vm = this
            vm.loading = true
            const response = await ApiUtils.makePatch(`provider/${vm.id}/account`, null, {
                subscription_paused: vm.subscription_paused ? 1 : 0,
            })
            vm.loading = false

            if (!response.ok) {
                const json = await response.json()
                vm.showSnackBar((json.result.pos_points ? json.result.pos_points[0] : json.message) || 'Ocurrió un error actualizando la cuenta')
                return
            }

            vm.$emit('success')
            vm.hideDialog()
        },
    }
}
</script>